// Дзеркало Prisma enum ScheduleScopeKind. Область розкладу семестру.
// Значення ідентичні apps/api/prisma/schema.prisma (перевіряє test/enums.spec.ts). Підписи — лише тут.
export const ScheduleScopeKind = {
    UNIVERSITY: 'UNIVERSITY',
    FACULTY: 'FACULTY',
};
/** Значення в порядку оголошення в схемі. */
export const SCHEDULE_SCOPE_KIND_VALUES = ['UNIVERSITY', 'FACULTY'];
export const SCHEDULE_SCOPE_KIND_LABELS = {
    UNIVERSITY: 'Університет',
    FACULTY: 'Факультет',
};
//# sourceMappingURL=schedule-scope-kind.js.map